var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getAllCompanyList } from '@/views/company/api/index';
import MixinChangeStore from '@/common/mixins/changeStore';
import MixinDingTalk from '@/common/mixins/dingtalk';
import { getCookie, getStorage } from '@lhb/cache';
var StoreChangePopover = /** @class */ (function (_super) {
    __extends(StoreChangePopover, _super);
    function StoreChangePopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StoreChangePopover.prototype, "storeInfo", {
        /* data */
        /* computed */
        get: function () {
            return this.$store.getters['getStoreInfo'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreChangePopover.prototype, "user", {
        get: function () {
            return this.$store.getters['getUserInfo'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreChangePopover.prototype, "enterpriseList", {
        get: function () {
            return this.$store.state.common.companies || [];
        },
        enumerable: false,
        configurable: true
    });
    /* hooks */
    StoreChangePopover.prototype.mounted = function () {
        var _this = this;
        if ((getCookie('newPmsToken') || getStorage('newPmsToken')) && !this.enterpriseList.length) {
            getAllCompanyList().then(function (data) {
                _this.$store.commit('UPDATE_COMPANIES', data);
            });
        }
    };
    /* method */
    StoreChangePopover.prototype.clickChangeCompany = function (id) {
        var _this = this;
        this.companyChange(id).then(function () {
            _this.$message.success('切换成功');
            _this.$refs.changeCompany.showPopper = false;
        });
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], StoreChangePopover.prototype, "delayCollapse", void 0);
    StoreChangePopover = __decorate([
        Component({
            components: {},
            mixins: [MixinDingTalk, MixinChangeStore],
        })
    ], StoreChangePopover);
    return StoreChangePopover;
}(Vue));
export default StoreChangePopover;
